import { render, staticRenderFns } from "./QueryBuilderSelector.vue?vue&type=template&id=53390fd7"
import script from "./QueryBuilderSelector.vue?vue&type=script&lang=js"
export * from "./QueryBuilderSelector.vue?vue&type=script&lang=js"
import style0 from "./QueryBuilderSelector.vue?vue&type=style&index=0&id=53390fd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports